import styled, { css } from "styled-components";

export const Container = styled.a`
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  background-color: transparent;
  border: 0;

  @media (min-width: 768px) {
    width: 20rem;
  }
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding: 1rem;

    svg {
      width: 1.5rem;
      height: 1.5rem;
      fill: ${theme.colors.gray};
    }

    > p {
      margin: 0;
      padding-left: 0.5rem;
      color: ${theme.colors.lightGray};
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    img {
      width: 100%;
      height: 12rem;
      object-fit: cover;
    }

    @media (min-width: 768px) {
      img {
        height: 13rem;
      }
    }
  `}
`;
export const Description = styled.div`
  ${({ theme }) => css`
    padding: 1rem;
    border-bottom: 1px solid ${theme.colors.ultraLightGray};

    p {
      margin: 0;
      font-size: 0.875rem;
      color: ${theme.colors.black};
    }

    span {
      font-size: 0.75rem;
      color: ${theme.colors.black};
      opacity: 0.5;
    }

    @media (min-width: 768px) {
      p {
        font-size: 1rem;
      }
    }
  `}
`;

export const Footer = styled.div`
  ${({ theme }) => css`
    padding: 1rem;
    display: flex;
    justify-content: space-between;
  `}
`;

export const ContentUser = styled.div`
  ${({ theme }) => css`
    display: flex;

    p {
      color: ${theme.colors.black};
      opacity: 0.5;
      font-size: 1rem;
    }

    span {
      color: ${theme.colors.black};
      padding-left: 0.25rem;
      font-size: 1rem;
    }
  `}
`;
